import { parseDateOnlyString } from "@gettactic/api";

/**
 * Canonical parser for API date strings (`yyyy-MM-dd`, with or without a
 * trailing fake `Z`). Returns local midnight, so date-fns `format` never
 * shifts to the previous day for viewers west of UTC — never use
 * `new Date("yyyy-MM-dd")` for these strings.
 */
export function dateParseISO(date: string) {
  return parseDateOnlyString(date);
}
